/*
  Const used for Task Definition and mapping used for showing the Task Card 
  TODO: We really should move this definitions to common package.
*/
export const ORDER_YOUR_SAFETY_SHOE = "Order your safety shoes";
export const I_9_DOCUMENT = "Pack I-9 documents for your appointment";
export const BADGE_PHOTO = "Take your badge photo";
export const NEW_HIRE_VIDEO = "Watch the new hire video";
export const EMPLOYMENT_PAPERWORK = "Complete employment paperwork";
export const CREATE_EMPLOYEE_A_TO_Z_ACCOUNT = "Set up A to Z Account";
export const UPLOAD_REQUIRED_DOCUMENTS = "Upload required documents";
export const I_9_AUTHORIZATION_FORM = "Complete your I-9 Employment Authorization Form";
export const COMPLETE_PRE_EMPLOYMENT_SCREENING = "Complete pre-employment screening";
export const PROVIDE_PERSONAL_INFORMATION = "Provide personal information";
export const COMPLETE_NEW_HIRE_ORIENTATION = "Complete new hire orientation";
export const BACKGROUNDCHECK_INFORMATION = "Provide background check information";
export const COMPLETE_RIGHT_TO_WORK = "Complete your Right to Work Documentation";
export const SCHEDULE_RIGHT_TO_WORK_APPOINTMENT = "Schedule a Right to Work appointment";
export const DOC_UPLOADS = "Upload documents";
export const BGC = "BGC";
export const AIR_BGC = "AIR BGC";
export const DRUG_TEST = "Drug Test";
export const MEDICAL_CHECK = "Medical Check";

/* Const used for TaskGroup */
export const PRE_HIRE_APPOINTMENT_GROUP = "Pre-hire appointment group";
export const FIRST_DAY_GROUP = "First day group";

/* Const used for differentiate Task and Subtask */
export const TASK = "TASK";
export const SUBTASK = "SUBTASK";
